import React from 'react';
import JobList from '../../../features/jobs/components/JobList';
import useSavedJobs from '../../../features/jobs/hooks/useSavedJobs';
import CardIcon from '../../../shared/components/icons/CardIcon';

function SavedJobs() {
  const { jobs, loading, error, setJobs } = useSavedJobs();

  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-white p-6 sm:p-8 shadow-sm">
        <h1 className="flex items-center gap-3 text-2xl sm:text-3xl font-bold tracking-tight text-navy"><CardIcon name="bookmark" className="h-7 w-7" />Saved jobs</h1>
        <p className="mt-2 text-sm text-slate-600">View the jobs you've saved and return to them quickly.</p>
      </div>

      <JobList jobs={jobs} loading={loading} error={error} savedView onUnsave={(jobId) => setJobs((current) => current.filter((job) => job.id !== jobId))} />
    </div>
  );
}

export default SavedJobs;
